import { topicsOpt } from "../options";

function displayTopics(topics) {
    let topicsText = "";

    topics.map((element) => {
        let newElement = {};
        newElement = topicsOpt.find((item) => item.id == element.topic_id);
        if (topics.length > 1) topicsText += `${newElement.text},`;
        else topicsText = newElement.text;
    });

    return topicsText;
}

function checkCount(count) {
    if (count) return count;
    return 0;
}

export function getCustomFields(v) {
    let newObj = {
        Date: v.date,
        "  Code": v.mdrtb_code,
        "  Year": v.mdrtb_year,
        "Mono-Poly":v.patient?(parseInt(v.patient.mdrtb_monopoly) == 2 ? "Yes" : parseInt(v.patient.mdrtb_monopoly) == 3 ? "SG" : parseInt(v.patient.mdrtb_monopoly) == 4 ? "MGY" : 'No'):'',
        Township: v.township.name,
        Township_Code:v.township.short_code,
        "Township Group ": parseInt(v.township.township_group_id) == 1 ? "MDR 1 " : parseInt(v.township.township_group_id) == 2 ? "MDR 2" : '',
        Phone: v.phone,
        Topics: displayTopics(v.topics),
        "Household members less than 5": checkCount(v.less_than_5_count),
        "Household members between 5 and 14": checkCount(
            v.between_5_and_14_count,
        ),
        "Household members greater than 15": checkCount(v.greate_than_15),
    };
    return newObj;
}